import apiClient from './apiClient';

export const lexwareIntegrationApi = {
  get: async () => {
    const response = await apiClient.get('/lexware-integration');
    return response.data;
  },

  save: async (data) => {
    const response = await apiClient.post('/lexware-integration', data);
    return response.data;
  },

  delete: async () => {
    const response = await apiClient.delete('/lexware-integration');
    return response.data;
  },

  testConnection: async () => {
    const response = await apiClient.post('/lexware-integration/test');
    return response.data;
  },

  triggerSync: async () => {
    const response = await apiClient.post('/lexware-integration/sync');
    return response.data;
  },

  getStatus: async () => {
    const response = await apiClient.get('/lexware-integration/status');
    return response.data;
  },

  getLogs: async (params = {}) => {
    const response = await apiClient.get('/lexware-integration/logs', { params });
    return response.data;
  },

  getKundenRechnungen: async (kundeId) => {
    const response = await apiClient.get(`/lexware-integration/kunden/${kundeId}/rechnungen`);
    return response.data;
  },

  createAngebot: async (anfrageId) => {
    const response = await apiClient.post('/lexware-integration/angebot', { anfrageId });
    return response.data;
  },
};
